export default __webpack_public_path__ + "static/Setup-2a0773618433c3da5fb670397e474ec4.png";